"use client";

import React, { useEffect, useState } from "react";
import { LogOut } from "lucide-react";
import { Button } from "./button";
import { KsaFlag, UkFlag } from "./flags";
import { Select, SelectContent, SelectItem, SelectTrigger } from "./select";

export interface AppHeaderActionsProps {
  currentLanguage: string;
  onLanguageToggle: () => void;
  onSignOut?: () => void;
  signOutLabel?: string;
}

export function AppHeaderActions({
  currentLanguage,
  onLanguageToggle,
  onSignOut,
  signOutLabel = "Sign out",
}: AppHeaderActionsProps) {
  const [mounted, setMounted] = useState(false);

  useEffect(() => {
    setMounted(true);
  }, []);

  if (!mounted) return null;

  return (
    <div className="flex items-center gap-3">
      <Select
        value={currentLanguage}
        onValueChange={(val) => {
          if (val !== currentLanguage) {
            onLanguageToggle();
          }
        }}
      >
        <SelectTrigger
          className="h-10 w-[105px] shrink-0 border border-outline-variant/50 bg-surface-container-lowest/80 px-3 backdrop-blur-md hover:bg-surface-container-low focus:outline-none focus:ring-2 focus:ring-primary"
          title="Select Language"
        >
          <div className="flex items-center gap-2">
            {currentLanguage === "en" ? (
              <UkFlag size={18} style={{ borderRadius: "50%", overflow: "hidden" }} />
            ) : (
              <KsaFlag size={18} style={{ borderRadius: "50%", overflow: "hidden" }} />
            )}
            <span className="font-body text-xs font-semibold uppercase text-surface-on">
              {currentLanguage === "en" ? "EN" : "AR"}
            </span>
          </div>
        </SelectTrigger>
        <SelectContent className="min-w-[120px] rounded-xl border border-outline-variant/50 bg-surface-container-lowest p-1 shadow-modal">
          <SelectItem value="en">
            <div className="flex items-center gap-2">
              <UkFlag size={18} style={{ borderRadius: "50%", overflow: "hidden" }} />
              <span className="font-body text-xs font-semibold">EN</span>
            </div>
          </SelectItem>
          <SelectItem value="ar">
            <div className="flex items-center gap-2">
              <KsaFlag size={18} style={{ borderRadius: "50%", overflow: "hidden" }} />
              <span className="font-body text-xs font-semibold">عربي</span>
            </div>
          </SelectItem>
        </SelectContent>
      </Select>

      {onSignOut && (
        <Button
          type="button"
          variant="ghost"
          size="sm"
          onClick={onSignOut}
          className="gap-2 text-surface-on-variant hover:text-error"
        >
          <LogOut className="size-4" />
          <span className="hidden sm:inline">{signOutLabel}</span>
        </Button>
      )}
    </div>
  );
}
